import styled from "styled-components";
import { LayoutConst } from "../../../core";
import { Colors } from "@brg/ui";

export const ImportModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${p => p.theme.commonCheckbox.bg};
  width: 720px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px 40px;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    height: auto;
    min-height: auto;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    padding: 16px 16px 40px;
  }
`;

export const ImportSuccessModalBody = styled(ImportModalBody)`

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: auto;
    min-height: auto;
  }
`;

export const CloseModalIconWrapper = styled.div`
  position: absolute;
  right: 0;
  cursor: pointer;

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`;

export const ImportModalHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
`;

export const ImportModalTitle = styled.h2`
  font-family: "Inter";
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};
  margin-bottom: 8px;
  
  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const ImportModalDescription = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${p => p.theme.not_saved_modal.channelTitle || '#151514'};
  margin: 0;
  text-align: left;  
  
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const ImportModalError = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #C64839;
  margin: 0;
  white-space: pre-line;
`;

export const ImportModalErrorInputBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
    
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 72px;
  }
`;

export const ImportInputRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    gap: 8px;
    flex-direction: column;
  }
`;

export const ImportModalInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  background: #F2F2F2;
  border: 1px solid transparent;
  border-radius: 3px;
  font-family: "Inter";
  font-size: 13px;
  line-height: 16px;
  color: #151514;

  &::placeholder {
    color: #909090;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
  }
`;

export const ImportSuccessButtonRow = styled.div`
  display: flex;
  justify-content: start;
  margin-top: auto;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 72px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background-color: ${Colors.galBlack47};
  margin: 16px 0;
`;
import styled from "styled-components";
import { LayoutConst } from "../../../core";
import { Colors } from "@brg/ui";

export const ImportModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${p => p.theme.commonCheckbox.bg};
  width: 720px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px 40px;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    height: auto;
    min-height: auto;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    padding: 16px 16px 40px;
  }
`;

export const ImportSuccessModalBody = styled(ImportModalBody)`

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: auto;
    min-height: auto;
  }
`;

export const CloseModalIconWrapper = styled.div`
  position: absolute;
  right: 0;
  cursor: pointer;

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`;

export const ImportModalHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
`;

export const ImportModalTitle = styled.h2`
  font-family: "Inter";
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.app.text};
  margin-bottom: 8px;
  
  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const ImportModalDescription = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${p => p.theme.not_saved_modal.channelTitle || '#151514'};
  margin: 0;
  text-align: left;  
  
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const ImportModalError = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #C64839;
  margin: 0;
  white-space: pre-line;
`;

export const ImportModalErrorInputBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
    
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 72px;
  }
`;

export const ImportInputRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    gap: 8px;
    flex-direction: column;
  }
`;

export const ImportModalInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  background: #F2F2F2;
  border: 1px solid transparent;
  border-radius: 3px;
  font-family: "Inter";
  font-size: 13px;
  line-height: 16px;
  color: #151514;

  &::placeholder {
    color: #909090;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%;
  }
`;

export const ImportSuccessButtonRow = styled.div`
  display: flex;
  justify-content: start;
  margin-top: auto;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    margin-top: 72px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  background-color: ${Colors.galBlack47};
  margin: 16px 0;
`;
